import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        selectedPath: '/',
        selectedIndex: 0,
        comparisons: [
            {
                id: 'busCards',
                image: '/items/bus.svg',
                units: '#value# stk.',
                text: '180 dagers periodebilletter for farte-buss',
                textDetails: 'farte-buss periodebilletter',
                info: '180 dagers periodebilletter\nfor farte-buss, 2500 kr Voksen.',
            },
            {
                id: 'joggingShoes',
                image: '/items/shoes.svg',
                units: '#value# par',
                text: 'joggesko',
                info: 'Joggesko – 1000 kr pr par.',
            },
            {
                id: 'electricBikes',
                image: '/items/electric-bike.svg',
                units: '#value# stk.',
                text: 'elsykler',
                info: 'Elsykkel – 30.000 kr pr sykkel.',
            },
            {
                id: 'electricScooterRides',
                image: '/items/farteelcitybike.svg',
                units: '#value# turer',
                text: 'med farte\nel-bysykkel',
                info: 'Turer med farte el-bysykkel\n10 kr pr 15 min. tur',
            },
            {
                id: 'carRental',
                image: '/items/long-term-rental-car.svg',
                units: '#value# dager',
                text: 'med leiebil',
                info: 'Leiebil - 2090 kr pr dag.'
            },
            {
                id: 'taxiRides',
                image: '/items/taxi.svg',
                units: '#value# turer',
                text: 'med taxi',
                info: 'Taxiturer – 305 kr pr tur.',
            }
        ],
        priceInfo: {
            joggingShoes: {
                unit: 'Per par',
                price: 1000,
                description: '',
                unitsPerYear: 1
            },
            electricBikes: {
                unit: 'stk.',
                price: 30000,
                description: '',
                unitsPerYear: 1
            },
            busCards: {
                unit: 'Per billett',
                price: 2500,
                description: '',
                unitsPerYear: 1
            },
            electricScooterRides: {
                unit: 'Per 10 min tur',
                price: 10,
                description: '',
                unitsPerYear: 1
            },
            carRental: {
                unit: 'Per dag',
                price: 2090,
                description: '',
                unitsPerYear: 1
            },
            taxiRides: {
                unit: 'Per tur',
                price: 305,
                description: '',
                unitsPerYear: 1
            },
        },
        selections: [
            {
                label: 'Bil, gjennomsnitt',
                title: 'Kostnader ved å eie en gjennomsnittlig bil',
                type: 'vanlig bil',
                price: 520000,
                compareValues: {
                    joggingShoes: 2,
                    electricBikes: 2,
                    busCards: 2,
                    electricScooterRides: 200,
                    carRental: 10,
                    taxiRides: 30
                },
                // rest: 11943
                costs: {
                    writeOffs: 43066,
                    interest: 17023,
                    insurance: 8513,
                    trafficInsuranceFee: 2975,
                    maintenance: 5505,
                    fuel: 17474,
                    oil: 1455,
                    tires: 3112,
                    serviceRepairs: 7185,
                    tolls: 13200
                },
                total: 119508,
                video: '/videos/bil_2.mp4',
                fallback: '/videos/bil_2.png',
                idleTime: 4
            },
            {
                label: 'Bil, liten',
                title: 'Kostnader ved å eie en liten bil',
                type: 'liten bil',
                price: 250000,
                compareValues: {
                    joggingShoes: 1,
                    electricBikes: 1,
                    busCards: 1,
                    electricScooterRides: 200,
                    carRental: 5,
                    taxiRides: 20
                },
                // rest: 10079
                costs: {
                    writeOffs: 20193,
                    interest: 8300,
                    insurance: 5428,
                    trafficInsuranceFee: 2975,
                    maintenance: 4191,
                    fuel: 11450,
                    oil: 1013,
                    tires: 1948,
                    serviceRepairs: 5096,
                    tolls: 13200
                },
                total: 73793,
                video: '/videos/bil_1.mp4',
                fallback: '/videos/bil_1.png',
                idleTime: 4
            },
            {
                label: 'Bil, stor/SUV',
                title: 'Kostnader ved å eie en SUV/stor bil',
                type: 'stor bil/SUV',
                price: 850000,
                compareValues: {
                    joggingShoes: 3,
                    electricBikes: 3,
                    busCards: 4,
                    electricScooterRides: 200,
                    carRental: 15,
                    taxiRides: 40
                },
                // rest: 14483
                costs: {
                    writeOffs: 71808,
                    interest: 27489,
                    insurance: 11141,
                    trafficInsuranceFee: 2975,
                    maintenance: 6118,
                    fuel: 21733,
                    oil: 1576,
                    tires: 4168,
                    serviceRepairs: 7845,
                    tolls: 13200
                },
                total: 168053,
                video: '/videos/bil_3.mp4',
                fallback: '/videos/bil_3.png',
                idleTime: 4
            },
            {
                label: 'Elbil, gjennomsnitt',
                type: 'vanlig elbil',
                title: 'Kostnader ved å eie en gjennomsnittlig elbil',
                price: 500000,
                compareValues: {
                    joggingShoes: 2,
                    electricBikes: 1,
                    busCards: 2,
                    electricScooterRides: 200,
                    carRental: 10,
                    taxiRides: 20
                },
                // rest: 13268
                costs: {
                    writeOffs: 41009,
                    interest: 16421,
                    insurance: 8066,
                    trafficInsuranceFee: 2975,
                    maintenance: 5459,
                    fuel: 3499,
                    oil: 0,
                    tires: 3444,
                    serviceRepairs: 5056,
                    tolls: 6600
                },
                total: 92528,
                video: '/videos/bil_5.mp4',
                fallback: '/videos/bil_5.png',
                idleTime: 4
            },
            {
                label: 'Elbil, liten',
                title: 'Kostnader ved å eie en liten elbil',
                type: 'liten elbil',
                price: 250000,
                compareValues: {
                    joggingShoes: 1,
                    electricBikes: 1,
                    busCards: 1,
                    electricScooterRides: 200,
                    carRental: 5,
                    taxiRides: 5
                },
                // rest: 11039
                costs: {
                    writeOffs: 20943,
                    interest: 8085,
                    insurance: 5265,
                    trafficInsuranceFee: 2975,
                    maintenance: 4191,
                    fuel: 2688,
                    oil: 0,
                    tires: 1948,
                    serviceRepairs: 4131,
                    tolls: 6600
                },
                total: 56826,
                video: '/videos/bil_4.mp4',
                fallback: '/videos/bil_4.png',
                idleTime: 4
            },
            {
                label: 'Elbil, stor/SUV',
                title: 'Kostnader ved å eie en stor elbil/SUV',
                type: 'stor elbil/SUV',
                price: 850000,
                compareValues: {
                    joggingShoes: 3,
                    electricBikes: 2,
                    busCards: 3,
                    electricScooterRides: 200,
                    carRental: 15,
                    taxiRides: 50
                },
                // rest: 13019
                costs: {
                    writeOffs: 64502,
                    interest: 29415,
                    insurance: 10806,
                    trafficInsuranceFee: 2975,
                    maintenance: 6118,
                    fuel: 4300,
                    oil: 0,
                    tires: 5267,
                    serviceRepairs: 5514,
                    tolls: 6600
                },
                total: 135497,
                video: '/videos/bil_6.mp4',
                fallback: '/videos/bil_6.png',
                idleTime: 4
            }
        ],
        labels: {
            writeOffs: 'Avskrivninger',
            interest: 'Renter av bundet kapital',
            insurance: 'Forsikring',
            trafficInsuranceFee: 'Trafikkforsikringsavgift',
            maintenance: 'Vedlikehold',
            fuel: 'Drivstoff',
            oil: 'Olje',
            tires: 'Dekk',
            serviceRepairs: 'Service og reparasjoner',
            tolls: 'Bompenger'
        }
    },
    actions: {

    },
    mutations: {
        setSelectedPath (path) {
            state.selectedPath = path;
        },
        setSelectedIndex (state, index) {
            state.selectedIndex = index;
        }
    },
    getters: {
        activeSelection (state) {
            return state.selections[state.selectedIndex];
        },
        activeComparisons (state) {
            return state.comparisons.map(c => Object.assign({}, c, {
                value: state.selections[state.selectedIndex].compareValues[c.id],
                priceInfo: state.priceInfo[c.id],
                annualPrice: Math.round(state.priceInfo[c.id].price * state.selections[state.selectedIndex].compareValues[c.id] * state.priceInfo[c.id].unitsPerYear),
            }));        },
        activeDetails (state) {
            return Object.keys(state.labels)
                .map(k => ({label: state.labels[k], value: state.selections[state.selectedIndex].costs[k]}));
        }
    }
});
